// ------------------------------------------------------------------------------
// name: types
// author: mudas
// created: 2025/2/17
// ------------------------------------------------------------------------------

export const MAX_WIDTH = 512,
  MAX_VIDEO_SIZE = 20,
  MAX_IMAGE_SIZE = 50;

export const MAX_UPLOAD_IMAGE_W = 8192,
  MAX_UPLOAD_VIDEO_W = 3840;
